import React from 'react';

const CategoryFilter = ({ selectedCategory, setSelectedCategory, availableCategories = [] }) => {
  // Build categories list from props (database) + 'All Categories'
  const categories = [
    { value: 'all', label: 'All Categories' },
    ...availableCategories.map((cat) => ({
      value: cat,
      label: cat // Use category name as-is from database
    }))
  ];

  return (
    <div className="category-filter">
      <h4 className="filter-subtitle">Category</h4>
      <div className="category-options">
        {categories.map((category) => (
          <label key={category.value} className="category-option">
            <input
              type="radio"
              name="category"
              value={category.value}
              checked={selectedCategory === category.value}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className="category-radio"
            />
            <span className="category-label">{category.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;
